/*
 * Static global print styles for <PrintDialog />.
 *
 * These target elements outside the component's own DOM (#root / #print), so they live in a plain
 * (unscoped) stylesheet instead of a scoped Linaria class. They are gated behind `:has(#print > *)`
 * so they only apply while a <PrintDialog /> has portaled content into #print — mirroring the
 * original Emotion <Global> lifetime. Without this gate a plain Cmd+P on a page with no
 * <PrintDialog /> would hide #root and print the empty #print container.
 *
 * The two dynamic aspects (`print-color-adjust` and the `@page` size) can't be expressed statically,
 * so <PrintDialog /> injects them into a small <style> element while it is mounted.
 */

#print {
  display: none;
}

@media print {
  html:has(#print > *),
  body:has(#print > *) {
    height: auto;
    overflow: auto;
  }

  body:has(#print > *) #root {
    display: none;
  }

  body:has(#print > *) #root ~ *:not(#print) {
    visibility: hidden;
  }

  body:has(#print > *) #print {
    display: block;
  }
}
